import { create } from "zustand";
import type { TarotSpread } from "./types";

type SpreadStore = {
  selectedSpread: TarotSpread | null;
  setSelectedSpread: (TarotSpread: TarotSpread | null) => void;
};

const useSpreadStore = create<SpreadStore>()((set) => ({
  selectedSpread: null,
  setSelectedSpread: (TarotSpread) =>
    set(() => ({ selectedSpread: TarotSpread })),
}));

export default useSpreadStore;
